import { Sim } from './sim';

export class SimInfo {
  constructor(
    public readonly imei: string,
    public readonly index: boolean,
    public readonly sim: Sim | null
  ) {}
}
